angular.module('bizmetryApp').controller('UserEditDialogController', function (
    $scope, $mdDialog, $mdToast,
    UserService, geoLocationService, dialogService, user, roles, accountId
) {

    // ── Init ──────────────────────────────────────────────────────────────────
    // The user as loaded — the 2FA tab shows its registered number (and the Unlink button) from it
    $scope.user = user;
    $scope.editableUser = angular.copy(user);
    $scope.accountId = accountId;
    $scope.saving = false;
    $scope.hasChanges = false;
    $scope.activeTab = 0;

    // Roles
    $scope.selectedRoles = angular.copy(user.userRoles || []);

    // Trusted IPs / FQDNs
    $scope.trustedIps = (user.trustedIps || []).map(function (addr) {
        return { address: addr };
    });
    $scope.newIpAddress = '';
    $scope.ipAddError = '';
    $scope.validatingIp = false;

    // Snapshots
    var _originalFirstName = user.firstName;
    var _originalLastName = user.lastName;
    var _originalRolesJson = JSON.stringify(
        (user.userRoles || []).map(function (r) { return r.id; }).sort()
    );
    var _originalIpsJson = JSON.stringify(
        (user.trustedIps || []).slice().sort()
    );

    // ── Password ──────────────────────────────────────────────────────────────
    $scope.passwordValue = '';
    $scope.passwordValid = true;

    $scope.onPasswordChange = function (value, valid) {
        $scope.passwordValue = value;
        $scope.passwordValid = valid;
        $scope.checkForChanges();
    };

    // ── 2FA ───────────────────────────────────────────────────────────────────
    $scope.phoneValid = null;
    $scope.twoFaValidated = false;

    var _validatedPhone = user.user2FANumber || null;

    if (user.user2FANumber) {
        $scope.twoFaValidated = true;
    }

    $scope.$watch('editableUser.user2FANumber', function (newVal, oldVal) {
        if (newVal !== oldVal) {
            $scope.twoFaValidated = false;
            _validatedPhone = null;
            $scope.checkForChanges();
        }
    });

    $scope.$watch('phoneValid', function () { $scope.checkForChanges(); });

    $scope.canValidate2FA = function () {
        return !!(
            $scope.editableUser.user2FANumber &&
            $scope.phoneValid === true &&
            !$scope.twoFaValidated
        );
    };

    $scope.phoneNumberChangedAfterValidation = function () {
        return $scope.twoFaValidated &&
            $scope.editableUser.user2FANumber !== _validatedPhone;
    };

    $scope.openTwoFaValidation = function () {
        $mdDialog.show({
            template: [
                '<two-fa-validator',
                '    email="{{ $ctrl.email }}"',
                '    target-number="{{ $ctrl.targetNumber }}"',
                '    on-success="$ctrl.onSuccess()"',
                '    on-cancel="$ctrl.onCancel()">',
                '</two-fa-validator>'
            ].join(''),
            controller: function ($mdDialog) {
                this.email = $scope.editableUser.email;
                this.targetNumber = $scope.editableUser.user2FANumber;
                this.onSuccess = function () { $mdDialog.hide({ success: true }); };
                this.onCancel = function () { $mdDialog.cancel(); };
            },
            controllerAs: '$ctrl',
            clickOutsideToClose: false,
            escapeToClose: false,
            multiple: true
        })
            .then(function (result) {
                if (result && result.success) {
                    $scope.twoFaValidated = true;
                    _validatedPhone = $scope.editableUser.user2FANumber;
                    $scope.checkForChanges();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('✅ Phone number verified')
                            .position('top right')
                            .hideDelay(2500)
                    );
                }
            })
            .catch(function () { });
    };

    // ── Helpers ───────────────────────────────────────────────────────────────
    $scope.getShortId = function (uuid) {
        if (!uuid) return 'N/A';
        return uuid.replace(/-/g, '').slice(-10).toUpperCase();
    };

    $scope.getRolesCount = function () {
        return $scope.selectedRoles.filter(function (r) { return r.type !== 'PERMISSION'; }).length;
    };

    $scope.getPermissionsCount = function () {
        return $scope.selectedRoles.filter(function (r) { return r.type === 'PERMISSION'; }).length;
    };

    // ── Role management ───────────────────────────────────────────────────────
    $scope.removeRole = function (role) {
        $scope.selectedRoles = $scope.selectedRoles.filter(function (r) {
            return r.id !== role.id;
        });
        $scope.checkForChanges();
    };

    $scope.openRoleExplorer = function () {
        $mdDialog.show({
            controller: 'RoleExplorerPickerController',
            templateUrl: '/home/main-menu/users/tabs/user-management/role-picker/role-explorer-picker.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            escapeToClose: true,
            multiple: true,
            locals: {
                selectedRoles: angular.copy($scope.selectedRoles),
                accountId: accountId
            }
        })
            .then(function (result) {
                if (result && result.selectedRoles) {
                    $scope.selectedRoles = result.selectedRoles;
                    $scope.checkForChanges();
                }
            })
            .catch(function () { });
    };

    // ── Trusted IP / FQDN management ──────────────────────────────────────────
    var _IP_V4 = /^(\d{1,3}\.){3}\d{1,3}$/;
    var _IP_V6 = /^[0-9a-fA-F:]{2,39}$/;
    var _FQDN = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

    function isValidEntry(value) {
        if (!value) return false;
        var s = value.trim();

        if (_IP_V4.test(s)) {
            return s.split('.').every(function (o) {
                var n = parseInt(o, 10);
                return n >= 0 && n <= 255;
            });
        }

        if (_IP_V6.test(s)) return true;

        return _FQDN.test(s);
    }

    function isFqdn(value) {
        return _FQDN.test((value || '').trim());
    }

    // Icono dinámico para el listado
    $scope.getEntryIcon = function (address) {
        return isFqdn(address) ? 'language' : 'router';
    };

    $scope.addTrustedIp = function () {
        $scope.ipAddError = '';
        var addr = ($scope.newIpAddress || '').trim();

        if (!addr) return;

        if (!isValidEntry(addr)) {
            $scope.ipAddError = 'Enter a valid IPv4, IPv6 or domain name (e.g. myserver.example.com)';
            return;
        }

        if ($scope.trustedIps.some(function (e) { return e.address === addr; })) {
            $scope.ipAddError = 'This address is already in the list';
            return;
        }

        $scope.validatingIp = true;

        geoLocationService.geolocate(addr)
            .then(function (geo) {
                if (!geo || !geo.country_code) {
                    $scope.ipAddError = isFqdn(addr)
                        ? 'Domain could not be resolved. Make sure it is publicly accessible.'
                        : 'IP address could not be resolved. Make sure it is a public, accessible IP.';
                    return;
                }

                $scope.trustedIps.push({ address: addr });
                $scope.newIpAddress = '';
                $scope.checkForChanges();
            })
            .catch(function () {
                $scope.ipAddError = 'Address could not be resolved. Make sure it is public and accessible.';
            })
            .finally(function () {
                $scope.validatingIp = false;
            });
    };

    $scope.removeTrustedIp = function (entry) {
        $scope.trustedIps = $scope.trustedIps.filter(function (e) {
            return e.address !== entry.address;
        });
        $scope.checkForChanges();
    };

    // ── Detectar y agregar IP pública actual ──────────────────────────────────
    $scope.loadingMyIp = false;

    $scope.addMyIp = function () {
        if ($scope.loadingMyIp) return;

        $scope.loadingMyIp = true;
        $scope.ipAddError = '';

        geoLocationService.geolocate(null)
            .then(function (geo) {
                if (!geo || !geo.ip) {
                    $scope.ipAddError = 'Could not detect your public IP address.';
                    return;
                }

                var addr = geo.ip.trim();

                if ($scope.trustedIps.some(function (e) { return e.address === addr; })) {
                    $scope.ipAddError = 'Your IP ' + addr + ' is already in the list.';
                    return;
                }

                $scope.trustedIps.push({ address: addr });
                $scope.checkForChanges();

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('📍 Your IP ' + addr + ' has been added')
                        .position('top right')
                        .hideDelay(2500)
                );
            })
            .catch(function () {
                $scope.ipAddError = 'Could not detect your public IP address.';
            })
            .finally(function () {
                $scope.loadingMyIp = false;
            });
    };

    // ── Change detection ──────────────────────────────────────────────────────
    $scope.checkForChanges = function () {
        var nameChanged = $scope.editableUser.firstName !== _originalFirstName ||
            $scope.editableUser.lastName !== _originalLastName;

        var currentRolesJson = JSON.stringify(
            $scope.selectedRoles.map(function (r) { return r.id; }).sort()
        );
        var rolesChanged = currentRolesJson !== _originalRolesJson;

        var currentIpsJson = JSON.stringify(
            $scope.trustedIps.map(function (e) { return e.address; }).sort()
        );
        var ipsChanged = currentIpsJson !== _originalIpsJson;

        var pwdChanged = !!$scope.passwordValue;

        var phoneChanged = ($scope.editableUser.user2FANumber || '') !== (user.user2FANumber || '');
        var phoneOk = phoneChanged && $scope.twoFaValidated;

        if (phoneChanged && !$scope.twoFaValidated) {
            $scope.hasChanges = false;
            return;
        }

        $scope.hasChanges = nameChanged || rolesChanged || ipsChanged || pwdChanged || phoneOk;
    };

    // ── Form validation ───────────────────────────────────────────────────────
    $scope.isFormValid = function () {
        if (!$scope.editableUser.firstName || !$scope.editableUser.firstName.trim()) return false;
        if (!$scope.editableUser.lastName || !$scope.editableUser.lastName.trim()) return false;
        if ($scope.selectedRoles.length === 0) return false;
        if ($scope.passwordValue && !$scope.passwordValid) return false;
        if (!$scope.hasChanges) return false;
        return true;
    };

    // ── Save ──────────────────────────────────────────────────────────────────
    $scope.saveUser = function () {
        if (!$scope.isFormValid() || $scope.saving) return;

        $scope.saving = true;

        var updateDTO = {
            firstName: $scope.editableUser.firstName.trim(),
            lastName: $scope.editableUser.lastName.trim(),
            email: $scope.editableUser.email,
            userEnabled: $scope.editableUser.userEnabled,
            userRoles: $scope.selectedRoles.map(function (r) {
                return { id: r.id, name: r.name, type: r.type };
            }),
            trustedIps: $scope.trustedIps.map(function (e) { return e.address; })
        };

        if ($scope.passwordValue) {
            updateDTO.password = $scope.passwordValue;
        }

        if ($scope.twoFaValidated &&
            ($scope.editableUser.user2FANumber || '') !== (user.user2FANumber || '')) {
            updateDTO.user2FANumber = $scope.editableUser.user2FANumber;
        }

        UserService.updateUser($scope.editableUser.id, $scope.accountId, updateDTO)
            .then(function (response) {
                $scope.saving = false;
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('✅ User updated successfully')
                        .position('top right')
                        .hideDelay(3000)
                );
                $mdDialog.hide(response.data);
            })
            .catch(function (error) {
                $scope.saving = false;
                var msg = (error.data && error.data.message) || 'Failed to update user';
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('❌ ' + msg)
                        .position('top right')
                        .hideDelay(4000)
                );
            });
    };

    // ── 2FA — Unlink ──────────────────────────────────────────────────────────
    // Removes the registered mobile number right away (PATCH user2FANumber: ""). Agents and
    // interceptors that alert this user by SMS uncheck them (UserChangedEvent).
    $scope.unlinking = false;
    var unlinkedUser = null;

    $scope.unlink2FA = function () {
        dialogService.showDecisionDialog(
            'Unlink 2FA Device',
            'Unlink the mobile number <strong>' + user.user2FANumber + '</strong> from <strong>' + user.email + '</strong>? '
                + 'The user will no longer receive 2FA codes or SMS alerts — agents and interceptors that alert them by '
                + 'SMS stop doing so — until a new number is validated.',
            { goBack: 'Cancel', proceed: 'Unlink' }
        ).then(function (decision) {
            if (decision !== 'proceed') { return; }
            $scope.unlinking = true;
            UserService.updateUser($scope.editableUser.id, $scope.accountId, { user2FANumber: '', user2FAEnabled: false })
                .then(function (response) {
                    unlinkedUser = response.data || null;
                    user.user2FANumber = null;
                    user.user2FAEnabled = false;
                    $scope.editableUser.user2FANumber = '';
                    $scope.twoFaValidated = false;
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('✅ 2FA device unlinked')
                            .position('top right')
                            .hideDelay(3000)
                    );
                })
                .catch(function (error) {
                    var msg = (error.data && error.data.message) || 'Failed to unlink the 2FA device';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('❌ ' + msg)
                            .position('top right')
                            .hideDelay(4000)
                    );
                })
                .finally(function () { $scope.unlinking = false; });
        });
    };

    // ── Dialog ────────────────────────────────────────────────────────────────
    // After an unlink the user did change: close as "updated" so the list refreshes.
    $scope.cancel = function () {
        if (unlinkedUser) { $mdDialog.hide(unlinkedUser); } else { $mdDialog.cancel(); }
    };
});